import React from 'react';
import { MDText } from 'i18n-react';
import noop from 'lodash/noop';

import { Badge } from '@motorway/mw-highway-code';

import type { TimeLeft } from 'Components/shared/TimeCountdown/TimeCountdown';
import TimeCountdown from 'Components/shared/TimeCountdown/TimeCountdown';
import useSaleTimes from 'Utilities/hooks/useSaleTimes';

import statusBadgeTexts from '../StatusBadge.texts';

import styles from './SaleCountdown.module.scss';

const LocalT = new MDText(statusBadgeTexts);

const isValidTimeLeft = (timeLeft: TimeLeft | boolean): timeLeft is TimeLeft => {
	return typeof timeLeft !== 'boolean';
};

const SaleCountdownText: React.FC<{ timeLeft: TimeLeft }> = ({ timeLeft }) => {
	const { days, hours, minutes, seconds } = timeLeft;

	const isFinalMinute = days === 0 && hours === 0 && minutes === 0;

	const countdownText = isFinalMinute
		? LocalT.translate('saleCountdownFinalMinute', {
				seconds,
		  })
		: LocalT.translate('saleCountdown', {
				hours,
				minutes,
		  });

	return (
		<span suppressHydrationWarning className={styles.text}>
			{countdownText}
		</span>
	);
};

export const SaleCountdown: React.FC = () => {
	const { todaysSaleEndsAt } = useSaleTimes();

	return (
		<TimeCountdown countdownTime={todaysSaleEndsAt} timeDifference={0} whenCountdownEnds={noop}>
			{({ timeLeft }) => {
				return isValidTimeLeft(timeLeft) ? (
					<Badge reverse text={<SaleCountdownText timeLeft={timeLeft} />} variant="success" />
				) : null;
			}}
		</TimeCountdown>
	);
};
